import React from 'react';
import { faChevronRight, faPlay } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { MegaMenu } from 'components/mega-menu/megaMenu';
import { useAppDispatch, useAppSelector } from 'ducks/hooks';
import { clearJob } from 'ducks/job/slices';
import { selectJobDefinition } from 'ducks/job-definition/selectors';
import { setJobDefinition } from 'ducks/job-definition/slices';
import { setModal } from 'ducks/modals/slices';
import { selectProject } from 'ducks/project/selectors';
import { selectProjects } from 'ducks/projects/selectors';
import { updateSettings } from 'ducks/settings/slices';
import { Link, useParams } from 'react-router-dom';
import { handleError } from 'utils/errors';
import { replaceSearchQuery } from 'utils/queries';

import cn from 'components/breadcrumbs/Breadcrumbs.module.scss';

interface ParamsProps {
  project_id?: number;
}

export const JobDefinition = () => {
  const dispatch = useAppDispatch();
  const { project_id }: ParamsProps = useParams();

  const job_definition = useAppSelector(selectJobDefinition);
  const project = useAppSelector(selectProject);
  const projects = useAppSelector(selectProjects);

  const getJobsRoute = () => {
    const query = replaceSearchQuery({ filter: null });
    return `/projects/${project_id}/job_definitions/all${query}`;
  };

  const runJobDefinition = async () => {
    try {
      dispatch(clearJob());
      dispatch(setJobDefinition(job_definition));
      dispatch(setModal({ run_job_definition: true }));
    } catch (err) {
      handleError(err);
    }
    dispatch(updateSettings({ loading: false }));
  };

  const project_name = `${project.project_name ?? 'Projects'}`;
  return (
    <div className={cn.items}>
      <MegaMenu labels={project_name} values={projects} page="job_definitions" />
      <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
      <Link to={getJobsRoute()} className={cn.item}>
        Job Definitions
      </Link>
      <FontAwesomeIcon className={cn.breadcrumbIcon} icon={faChevronRight} />
      <p className={cn.item}>{job_definition.job_definition_name || 'Job Definition'}</p>
      <div className={cn.flexGrow} />
      <div className={classNames(cn.action, cn.actionPlay)} onClick={runJobDefinition}>
        <FontAwesomeIcon icon={faPlay} color="#5cb85c" />
        <span className={cn.actionText}>Run</span>
      </div>
    </div>
  );
};
